import { ReactNode } from 'react'
import { Box } from '@mui/material'

/**
 * A bordered surface around one subject (design system: Card, static
 * variant): an optional header strip — uppercase title on panel-head, one
 * action on the right — over the body.
 */
export const Panel = ({
  title,
  action,
  children,
  bodyPadding = '12px',
}: {
  title?: string
  action?: ReactNode
  children: ReactNode
  bodyPadding?: string
}) => (
  <Box
    component="section"
    sx={{
      display: 'flex',
      flexDirection: 'column',
      minWidth: 0,
      background: 'var(--surface-0)',
      border: '1px solid var(--line-200)',
      borderRadius: 'var(--radius-md)',
      boxShadow: 'var(--shadow-panel)',
      overflow: 'hidden',
    }}
  >
    {title && (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          minHeight: 36,
          px: '12px',
          background: 'var(--panel-head)',
          borderBottom: '1px solid var(--line-200)',
        }}
      >
        <Box
          component="h2"
          sx={{
            m: 0,
            flex: 1,
            fontSize: 10.5,
            fontWeight: 700,
            letterSpacing: '0.05em',
            textTransform: 'uppercase',
            color: 'var(--ink-500)',
          }}
        >
          {title}
        </Box>
        {action}
      </Box>
    )}
    <Box sx={{ p: bodyPadding, minWidth: 0 }}>{children}</Box>
  </Box>
)
